import React, { useEffect, useMemo, useState } from 'react';

import RoundDitailSP from '../../RoundDitailSP';
import { buildBetDisplayItems, normalizeBetChoices } from '../../betLabels';
import BetContextStickyBarSP from './BetContextStickyBarSP';

const parseAnswers = (rawAnswers) => {
  if (Array.isArray(rawAnswers)) {
    return normalizeBetChoices(rawAnswers);
  }

  if (typeof rawAnswers === 'string') {
    const trimmed = rawAnswers.trim();
    if (!trimmed) {
      return [];
    }

    try {
      const parsed = JSON.parse(trimmed);
      return normalizeBetChoices(parsed);
    } catch (error) {
      console.error('Error parsing answers JSON', error);
      return [];
    }
  }

  return [];
};

function BetTimeRoomContentSP({ isRoomPointInsufficient, viewProps }) {
  const [isBetTargetVisible, setIsBetTargetVisible] = useState(null);
  const choices = useMemo(
    () => parseAnswers(viewProps?.round?.answers),
    [viewProps?.round?.answers],
  );
  const betDisplayItems = useMemo(
    () => buildBetDisplayItems(choices),
    [choices],
  );
  const canShowStickyBar =
    isBetTargetVisible === false &&
    betDisplayItems.length >= 2;

  useEffect(() => {
    setIsBetTargetVisible(null);
  }, [viewProps?.round?.number]);

  return (
    <>
      {canShowStickyBar && (
        <BetContextStickyBarSP
          event={viewProps.event}
          items={betDisplayItems}
          round={viewProps.round}
        />
      )}
      <RoundDitailSP
        {...viewProps}
        betDisplayItems={betDisplayItems}
        isRoomPointInsufficient={isRoomPointInsufficient}
        onBetTargetVisibilityChange={setIsBetTargetVisible}
      />
    </>
  );
}

export default BetTimeRoomContentSP;
